<template>
  <div class="wrapper">
    <div class="bgc">
      <div class="shop-container">
        <div class="nav-bread">
          <router-link to="/">{{ $t("home") }}</router-link>
          <span>></span>
          <router-link :to="{ name: 'exam' }">{{ $t("exam") }}</router-link>
          <span>></span>
          <router-link :to="{ name: 'examitem', params: { id: examId } }">{{ topTitle }}</router-link>
          <span>></span>
          <span>{{ "错题" }}</span>
        </div>
        <div class="exam-box" v-loading="loading">
            <div class="title">{{ '错题列表' }}</div>
          <div v-if="startList.length > 0">
            <div class="list" v-for="(item, index) in startList" :key="index" @click="toCheck(item)">{{ (form.page-1)*10 + index + 1 }}、{{ item.name }}</div>
          </div>
          <div style="padding-top: 100px; width: 100%; text-align: center" v-else>
            {{ nodata }}
          </div>
        </div>
      </div>
    </div>
    <div class="pagination-wrap" v-if="total > 0">
      <pagination :totalPage="total" :limit="10" @changePage="changePage" />
    </div>
  </div>
</template>

<script>
import Pagination from "@/components/common/Pagination.vue";
export default {
  components: {
    Pagination,
  },
  data() {
    return {
      loading: false,
      topTitle: "详情",
      nodata: "暂无错题",
      examId: "",
      count: 0,
      startList: [],
      paper_id: "",
      form: {
        page: 1,
        limit: 10,
        paper_id: 0,
        model: 1,
        source:'pc'
      },
      loadStatus: "more",
      total: 0,
    };
  },

  mounted() {
    this.examId = JSON.parse(sessionStorage.getItem("nowPageData")) ;
    this.paper_id = this.$route.params.id;
    this.form.paper_id = this.paper_id;
    this.init();
    this.loading = true;
    this.topTitle = this.$route.params.title;
  },
  methods: {
    init() {
      this.$api.collectList(this.form).then((res) => {
        this.startList = res.data.list;
        this.total = Math.ceil(res.data.count / this.form.limit);
        this.loading = false;
      });
    },
    changePage(v) {
      this.form.page = v;
      this.init();
    },
    toCheck(e) {
      // // console.log(e);
      this.$router.push({
        name: "startDescript",
        params: { c_id: e.topic_id, paper_id: this.paper_id, title: this.topTitle, model: 1 },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/mixin.scss";
@import "@/assets/css/variable.scss";

::v-deep .el-tree-node__content {
  height: 42px;
}
::v-deep .el-tree-node > .el-tree-node__children {
  height: 52px;
}
.custom-tree-node {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  padding-right: 8px;
  // height: 107px;
}
.toExam {
  width: 110px;
  height: 42px;
  border: 1px solid rgba(231, 68, 47, 1);
  color: rgba(231, 68, 47, 1);
  display: flex;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
}
.class-item-wrap {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  .class-item {
    width: 296px;
    height: 200px;
    margin-top: 20px;
    margin-bottom: 30px;
    margin-left: 13px;
    cursor: pointer;
    position: relative;
    box-sizing: border-box;
    &:hover {
      box-shadow: 0 15px 20px rgba(0, 0, 0, 0.1);
    }
    // &:first-child {
    //   margin-left: 0;
    // }
    &:nth-child(4n + 1) {
      margin-left: 0;
    }
    .videp-cover {
      width: 296px;
      height: 200px;
    }
    .title {
      position: absolute;
      bottom: 0%;
      left: 0%;
      width: 100%;
      height: 50px;
      background: rgba(49, 44, 44, 0.5);
      text-align: center;
      line-height: 50px;
      color: white;
      font-size: 14px;
    }
  }
}
.exam-box {
  width: 100%;
  height: auto;
  padding: 52px 20px 40px;
  background-color: white;
  box-sizing: border-box;
  .title {
    width: 100%;
    height: 33px;
    line-height: 33px;
    font-size: 24px;
    font-weight: 400;
    text-align: center;
    margin-bottom: 30px;
  }
  .text_prc {
    width: 100%;
    // height: 22px;
    line-height: 22px;
    font-size: 16px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 30px;
    .text_prc_left {
      width: 40%;
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: left;
      .text_prc_left_title {
        margin-bottom: 32px;
        height: 22px;
        padding-left: 100px;
      }
    }
  }
}
.class-list {
  // background: #ffffff;
  width: 1226px;
  margin: 20px auto 0;
  // padding: 30px;
  margin-bottom: 20px;
  box-sizing: border-box;
}
.class-title {
  color: #333333;
  font-size: 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  span {
    display: inline-block;
    width: 6px;
    height: 38px;
    background: #ff6d6d;
    border-radius: 4px;
    margin-right: 7px;
  }
  .title-wrap {
    display: flex;
    align-items: center;
  }
}
.tr-foot {
  display: flex;
  // position: absolute;
  justify-content: center;
  margin-bottom: 40px;
  .btn {
    height: 45px;
    line-height: 45px;
    font-size: 14px;
    width: 180px;
    text-align: center;
    border: 1px solid $theme-color;
    margin-right: 20px;
    cursor: pointer;
    &.add-btn {
      color: $theme-color;
    }
    &.buy-btn {
      background: $theme-color;
      color: #fff;
    }
    &.sold-out {
      background: $theme-color;
      color: #fff;
      cursor: not-allowed;
      border: none;
    }
    &.disabled {
      background-color: rgb(245, 127, 112);
    }
  }
  .collete-btn {
    min-width: 45px;
    height: 47px;
    text-align: center;
    // padding-top: 5px;
    padding: 5px 5px;
    box-sizing: border-box;
    font-size: 12px;
    background: #fff;
    border: 1px solid $border;
    color: #bebebe;
    cursor: pointer;
    color: $theme-color;
    .icon {
      display: block;
      margin-bottom: 4px;
    }
    &:hover {
      color: $theme-color;
    }
  }
}
.list {
  width: 100%;
  padding: 0 0 23px;
  color: rgb(10, 33, 51);
  font-size: 16px;
  font-weight: 400;
  line-height: 23px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: break-all;
  -webkit-line-clamp: 2;
  border-bottom: 1px solid rgb(243, 244, 245);
  margin-bottom: 23px;
  &:last-child {
    border-bottom: 0px solid rgb(243, 244, 245);
  }
}
</style>
